const BASE = 'technical/program-planner';

export const getTrackerListApi = () => `${BASE}/plans`;
export const exportTrackerListApi = () => `${BASE}/plans`;
export const getTrackerSummaryApi = () => `${BASE}/tracker/summary`;
export const logPlanActivityApi = (planSlug) => `${BASE}/plans/${planSlug}/log-activity`;

export const raiseInvoiceApi = (planSlug) => `${BASE}/invoices/${planSlug}/raise`;
export const markInvoicePaidApi = (planSlug) => `${BASE}/invoices/${planSlug}/mark-paid`;
export const closeInvoiceApi = (planSlug) => `${BASE}/invoices/${planSlug}/close`;
